/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "./utils";
import { Icon } from "@aws-amplify/ui-react";
export default function MyIcon(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    { variantValues: { type: "warning" }, overrides: { MyIcon: {} } },
    {
      variantValues: { type: "alert" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15L9 15L9 13L11 13L11 15ZM11 11L9 11L9 5L11 5L11 11Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "info" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M9 5L11 5L11 7L9 7L9 5ZM9 9L11 9L11 15L9 15L9 9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "chat" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2 2L18 2L18 14L3.17 14L2 15.17L2 2ZM2 0C0.9 0 0.00999999 0.9 0.00999999 2L0 20L4 16L18 16C19.1 16 20 15.1 20 14L20 2C20 0.9 19.1 0 18 0L2 0ZM4 10L12 10L12 12L4 12L4 10ZM4 7L16 7L16 9L4 9L4 7ZM4 4L16 4L16 6L4 6L4 4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "checkmark" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M5.59 10.58L1.42 6.41L0 7.82L5.59 13.41L17.59 1.41L16.18 0L5.59 10.58Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(14.21%, 23.29%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "favorite_border" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M14.5 0C12.76 0 11.09 0.81 10 2.09C8.91 0.81 7.24 0 5.5 0C2.42 0 0 2.42 0 5.5C0 9.28 3.4 12.36 8.55 17.04L10 18.35L11.45 17.03C16.6 12.36 20 9.28 20 5.5C20 2.42 17.58 0 14.5 0ZM10.1 15.55L10 15.65L9.9 15.55C5.14 11.24 2 8.39 2 5.5C2 3.5 3.5 2 5.5 2C7.04 2 8.54 2.99 9.07 4.36L10.94 4.36C11.46 2.99 12.96 2 14.5 2C16.5 2 18 3.5 18 5.5C18 8.39 14.86 11.24 10.1 15.55Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 14.58%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "more_vert" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(41.67%, 18.75%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "bookmark_border" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M12 0L2 0C0.9 0 0 0.9 0 2L0 18L7 15L14 18L14 2C14 0.9 13.1 0 12 0ZM12 15L7 12.82L2 15L2 2L12 2L12 15Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.83%, 12.5%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "share" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M15 14.08C14.24 14.08 13.56 14.38 13.04 14.85L5.91 10.7C5.96 10.47 6 10.24 6 10C6 9.76 5.96 9.53 5.91 9.3L12.96 5.19C13.5 5.69 14.21 6 15 6C16.66 6 18 4.66 18 3C18 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 3.24 12.04 3.47 12.09 3.7L5.04 7.81C4.5 7.31 3.79 7 3 7C1.34 7 0 8.34 0 10C0 11.66 1.34 13 3 13C3.79 13 4.5 12.69 5.04 12.19L12.16 16.35C12.11 16.56 12.08 16.78 12.08 17C12.08 18.61 13.39 19.92 15 19.92C16.61 19.92 17.92 18.61 17.92 17C17.92 15.39 16.61 14.08 15 14.08ZM15 2C15.55 2 16 2.45 16 3C16 3.55 15.55 4 15 4C14.45 4 14 3.55 14 3C14 2.45 14.45 2 15 2ZM3 11C2.45 11 2 10.55 2 10C2 9.45 2.45 9 3 9C3.55 9 4 9.45 4 10C4 10.55 3.55 11 3 11ZM15 18.02C14.45 18.02 14 17.57 14 17.02C14 16.47 14.45 16.02 15 16.02C15.55 16.02 16 16.47 16 17.02C16 17.57 15.55 18.02 15 18.02Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 8.33%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "arrow-right" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M8 0L6.59 1.41L12.17 7L0 7L0 9L12.17 9L6.59 14.59L8 16L16 8L8 0Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(16.67%, 16.67%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "reply" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M7 4L7 0L0 7L7 14L7 9.9C12 9.9 15.5 11.5 18 15C17 10 14 5 7 4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 20.83%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "chat-bubble-outline" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M18 0L2 0C0.9 0 0 0.9 0 2L0 20L4 16L18 16C19.1 16 20 15.1 20 14L20 2C20 0.9 19.1 0 18 0ZM18 14L4 14L2 16L2 2L18 2L18 14Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "send" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2.01 3.03L9.52 6.25L2 5.25L2.01 3.03L2.01 3.03ZM9.51 11.75L2 14.97L2 12.75L9.51 11.75L9.51 11.75ZM0.00999999 0L0 7L15 9L0 11L0.00999999 18L21 9L0.00999999 0Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 12.5%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "favorite" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M10 18.35L8.55 17.03C3.4 12.36 0 9.28 0 5.5C0 2.42 2.42 0 5.5 0C7.24 0 8.91 0.81 10 2.09C11.09 0.81 12.76 0 14.5 0C17.58 0 20 2.42 20 5.5C20 9.28 16.6 12.36 11.45 17.04L10 18.35Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 12.5%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "shuffle" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M6.59 5.17L1.41 0L0 1.41L5.17 6.58L6.59 5.17ZM10.5 0L12.54 2.04L0 14.59L1.41 16L13.96 3.46L16 5.5L16 0L10.5 0ZM10.83 9.41L9.42 10.82L12.55 13.95L10.5 16L16 16L16 10.5L13.96 12.54L10.83 9.41L10.83 9.41Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(16.67%, 16.67%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "more_horiz" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM14 0C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0ZM8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(16.67%, 41.67%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "group" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M7 8.75C4.66 8.75 0 9.92 0 12.25L0 14L14 14L14 12.25C14 9.92 9.34 8.75 7 8.75ZM2.34 12C3.18 11.42 5.21 10.75 7 10.75C8.79 10.75 10.82 11.42 11.66 12L2.34 12ZM7 7C8.93 7 10.5 5.43 10.5 3.5C10.5 1.57 8.93 0 7 0C5.07 0 3.5 1.57 3.5 3.5C3.5 5.43 5.07 7 7 7ZM7 2C7.83 2 8.5 2.67 8.5 3.5C8.5 4.33 7.83 5 7 5C6.17 5 5.5 4.33 5.5 3.5C5.5 2.67 6.17 2 7 2ZM14.04 8.81C15.2 9.65 16 10.77 16 12.25L16 14L20 14L20 12.25C20 10.23 16.5 9.08 14.04 8.81L14.04 8.81ZM13 7C14.93 7 16.5 5.43 16.5 3.5C16.5 1.57 14.93 0 13 0C12.46 0 11.96 0.13 11.5 0.35C12.13 1.24 12.5 2.33 12.5 3.5C12.5 4.67 12.13 5.76 11.5 6.65C11.96 6.87 12.46 7 13 7Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 20.83%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "close" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.83%, 20.83%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "shopping_bag" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M14 4L12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4L2 4C0.9 4 0 4.9 0 6L0 18C0 19.1 0.9 20 2 20L14 20C15.1 20 16 19.1 16 18L16 6C16 4.9 15.1 4 14 4ZM8 2C9.1 2 10 2.9 10 4L6 4C6 2.9 6.9 2 8 2ZM14 18L2 18L2 6L4 6L4 8C4 8.55 4.45 9 5 9C5.55 9 6 8.55 6 8L6 6L10 6L10 8C10 8.55 10.45 9 11 9C11.55 9 12 8.55 12 8L12 6L14 6L14 18Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(16.67%, 8.33%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "delete" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M11 6L11 16L3 16L3 6L11 6ZM9.5 0L4.5 0L3.5 1L0 1L0 3L14 3L14 1L10.5 1L9.5 0ZM13 4L1 4L1 16C1 17.1 1.9 18 3 18L11 18C12.1 18 13 17.1 13 16L13 4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.83%, 12.5%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "edit" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M0 14.2524L0 18.0024L3.75 18.0024L14.81 6.94244L11.06 3.19244L0 14.2524ZM17.71 2.63244L15.37 0.292444C15.2775 0.19974 15.1676 0.126193 15.0466 0.0760114C14.9257 0.02583 14.796 4.44089e-16 14.665 0C14.534 0 14.4043 0.02583 14.2834 0.0760114C14.1624 0.126193 14.0525 0.19974 13.96 0.292444L12.13 2.12244L15.88 5.87244L17.71 4.04244C17.8027 3.94993 17.8762 3.84004 17.9264 3.71907C17.9766 3.59809 18.0024 3.46841 18.0024 3.33744C18.0024 3.20648 17.9766 3.07679 17.9264 2.95582C17.8762 2.83485 17.8027 2.72496 17.71 2.63244L17.71 2.63244Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 12.49%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "dashboard" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M21.1357 6.71786C20.5835 5.41089 19.783 4.22348 18.7786 3.22143C17.7765 2.21696 16.5891 1.41646 15.2821 0.864286C13.9243 0.289732 12.4855 0 11 0C9.51451 0 8.07567 0.289732 6.71786 0.864286C5.41089 1.41646 4.22348 2.21696 3.22143 3.22143C2.21696 4.22348 1.41646 5.41089 0.864286 6.71786C0.289732 8.07567 0 9.51451 0 11C0 14.2583 1.43147 17.3275 3.92612 19.4243L3.96786 19.4587C4.11027 19.5766 4.28951 19.6429 4.47366 19.6429L17.5288 19.6429C17.7129 19.6429 17.8922 19.5766 18.0346 19.4587L18.0763 19.4243C20.5685 17.3275 22 14.2583 22 11C22 9.51451 21.7078 8.07567 21.1357 6.71786ZM17.1237 17.7768L4.87634 17.7768C3.92758 16.9213 3.1693 15.8759 2.6507 14.7084C2.1321 13.541 1.86477 12.2775 1.86607 11C1.86607 8.55937 2.81629 6.26607 4.54241 4.54241C6.26853 2.81629 8.56183 1.86607 11 1.86607C13.4406 1.86607 15.7339 2.81629 17.4576 4.54241C19.1837 6.26853 20.1339 8.56183 20.1339 11C20.1339 13.5929 19.0413 16.0458 17.1237 17.7768ZM13.7377 7.59933C13.7008 7.56277 13.6509 7.54227 13.599 7.54227C13.547 7.54227 13.4972 7.56277 13.4603 7.59933L11.3855 9.67411C10.9263 9.55134 10.4181 9.6692 10.0571 10.0301C9.9293 10.1577 9.82788 10.3093 9.75868 10.4761C9.68948 10.643 9.65386 10.8218 9.65386 11.0025C9.65386 11.1831 9.68948 11.3619 9.75868 11.5288C9.82788 11.6956 9.9293 11.8472 10.0571 11.9748C10.1847 12.1026 10.3363 12.204 10.5031 12.2732C10.67 12.3424 10.8488 12.3781 11.0295 12.3781C11.2101 12.3781 11.3889 12.3424 11.5558 12.2732C11.7226 12.204 11.8742 12.1026 12.0018 11.9748C12.1728 11.8043 12.2958 11.5917 12.3583 11.3584C12.4208 11.1252 12.4206 10.8796 12.3578 10.6464L14.4326 8.57165C14.5087 8.49554 14.5087 8.37031 14.4326 8.2942L13.7377 7.59933ZM10.4598 5.10714L11.5402 5.10714C11.6482 5.10714 11.7366 5.01875 11.7366 4.91071L11.7366 2.94643C11.7366 2.83839 11.6482 2.75 11.5402 2.75L10.4598 2.75C10.3518 2.75 10.2634 2.83839 10.2634 2.94643L10.2634 4.91071C10.2634 5.01875 10.3518 5.10714 10.4598 5.10714ZM16.8438 10.4598L16.8438 11.5402C16.8438 11.6482 16.9321 11.7366 17.0402 11.7366L19.0045 11.7366C19.1125 11.7366 19.2009 11.6482 19.2009 11.5402L19.2009 10.4598C19.2009 10.3518 19.1125 10.2634 19.0045 10.2634L17.0402 10.2634C16.9321 10.2634 16.8438 10.3518 16.8438 10.4598ZM17.1556 5.61786L16.392 4.85424C16.355 4.81769 16.3052 4.79718 16.2532 4.79718C16.2013 4.79718 16.1514 4.81769 16.1145 4.85424L14.7248 6.24397C14.6882 6.28089 14.6677 6.33075 14.6677 6.3827C14.6677 6.43466 14.6882 6.48451 14.7248 6.52143L15.4884 7.28504C15.5645 7.36116 15.6897 7.36116 15.7658 7.28504L17.1556 5.89531C17.2317 5.8192 17.2317 5.69397 17.1556 5.61786ZM5.89531 4.85424C5.85839 4.81769 5.80854 4.79718 5.75659 4.79718C5.70463 4.79718 5.65478 4.81769 5.61786 4.85424L4.85424 5.61786C4.81769 5.65478 4.79718 5.70463 4.79718 5.75659C4.79718 5.80854 4.81769 5.85839 4.85424 5.89531L6.24397 7.28504C6.32009 7.36116 6.44531 7.36116 6.52143 7.28504L7.28504 6.52143C7.36116 6.44531 7.36116 6.32009 7.28504 6.24397L5.89531 4.85424ZM4.86161 10.2634L2.89732 10.2634C2.78929 10.2634 2.70089 10.3518 2.70089 10.4598L2.70089 11.5402C2.70089 11.6482 2.78929 11.7366 2.89732 11.7366L4.86161 11.7366C4.96964 11.7366 5.05804 11.6482 5.05804 11.5402L5.05804 10.4598C5.05804 10.3518 4.96964 10.2634 4.86161 10.2634Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: {
                transform:
                  "translate(calc(50% - 11px - 0px), calc(50% - 9.82px - 0.18px))",
              },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "settings" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M3.93138 0L2.35883 0L2.35883 7.86276L3.93138 7.86276L3.93138 0ZM13.5239 7.86276L8.49178 7.86276L7.86276 6.99785L7.86276 5.4253L8.49178 4.71766L13.5239 4.71766L14.153 5.50393L14.153 7.07648L13.5239 7.86276ZM5.66119 12.5804L0.629021 12.5804L0 11.7941L0 10.2216L0.629021 9.43531L5.66119 9.43531L6.29021 10.2216L6.29021 11.7941L5.66119 12.5804ZM11.7941 0L10.2216 0L10.2216 3.1451L11.7941 3.1451L11.7941 0ZM10.2216 9.43531L11.7941 9.43531L11.7941 18.8706L10.2216 18.8706L10.2216 9.43531ZM3.93138 14.153L2.35883 14.153L2.35883 18.8706L3.93138 18.8706L3.93138 14.153ZM16.3545 14.153L21.371 14.153L22 13.3667L22 11.8728L21.371 11.0865L16.3545 11.0865L15.7255 11.8728L15.7255 13.3667L16.3545 14.153ZM19.6569 0L18.0843 0L18.0843 9.43531L19.6569 9.43531L19.6569 0ZM18.0843 15.7255L19.6569 15.7255L19.6569 18.8706L18.0843 18.8706L18.0843 15.7255Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: {
                transform:
                  "translate(calc(50% - 11px - 0px), calc(50% - 9.44px - -0.44px))",
              },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "notification" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M9.02564 22C10.2667 22 11.2821 20.9846 11.2821 19.7436L6.76923 19.7436C6.76923 20.9846 7.78462 22 9.02564 22ZM15.7949 15.2308L15.7949 9.58974C15.7949 6.12615 13.9559 3.22667 10.7179 2.45949L10.7179 1.69231C10.7179 0.755897 9.96205 0 9.02564 0C8.08923 0 7.33333 0.755897 7.33333 1.69231L7.33333 2.45949C4.10667 3.22667 2.25641 6.11487 2.25641 9.58974L2.25641 15.2308L0 17.4872L0 18.6154L18.0513 18.6154L18.0513 17.4872L15.7949 15.2308ZM13.5385 16.359L4.51282 16.359L4.51282 9.58974C4.51282 6.7918 6.21641 4.51282 9.02564 4.51282C11.8349 4.51282 13.5385 6.7918 13.5385 9.58974L13.5385 16.359Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: {
                transform:
                  "translate(calc(50% - 9.03px - -0.03px), calc(50% - 11px - 0px))",
              },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "twitter" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M19.7386 4.45304C19.7526 4.64846 19.7526 4.84393 19.7526 5.03935C19.7526 11 15.2158 17.8681 6.92388 17.8681C4.36929 17.8681 1.99621 17.1282 0 15.844C0.362958 15.8858 0.711909 15.8998 1.08883 15.8998C3.19667 15.8998 5.13706 15.1879 6.68656 13.9734C4.70432 13.9315 3.04314 12.6333 2.4708 10.8465C2.75001 10.8883 3.02918 10.9163 3.32236 10.9163C3.72717 10.9163 4.13202 10.8604 4.5089 10.7627C2.44291 10.3439 0.893367 8.5292 0.893367 6.33757L0.893367 6.28175C1.4936 6.61678 2.19163 6.82617 2.93143 6.85406C1.71695 6.04439 0.921297 4.66243 0.921297 3.09896C0.921297 2.26141 1.14461 1.49364 1.53549 0.823585C3.75505 3.55963 7.09138 5.34641 10.8325 5.54187C10.7627 5.20684 10.7208 4.85789 10.7208 4.5089C10.7208 2.02409 12.731 0 15.2297 0C16.5279 0 17.7005 0.544416 18.5241 1.42386C19.5431 1.22844 20.5203 0.851515 21.3858 0.335029C21.0507 1.38201 20.3388 2.26145 19.4036 2.81979C20.3109 2.72212 21.1904 2.4708 22 2.12185C21.3859 3.01521 20.6181 3.81087 19.7386 4.45304Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 4.7%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "instagram" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M11.0025 5.35828C7.88098 5.35828 5.36319 7.87607 5.36319 10.9975C5.36319 14.119 7.88098 16.6368 11.0025 16.6368C14.1239 16.6368 16.6417 14.119 16.6417 10.9975C16.6417 7.87607 14.1239 5.35828 11.0025 5.35828ZM11.0025 14.6638C8.98528 14.6638 7.3362 13.0196 7.3362 10.9975C7.3362 8.97546 8.98037 7.33129 11.0025 7.33129C13.0245 7.33129 14.6687 8.97546 14.6687 10.9975C14.6687 13.0196 13.0196 14.6638 11.0025 14.6638ZM18.1877 5.12761C18.1877 5.8589 17.5988 6.44295 16.8724 6.44295C16.1411 6.44295 15.5571 5.85399 15.5571 5.12761C15.5571 4.40123 16.146 3.81227 16.8724 3.81227C17.5988 3.81227 18.1877 4.40123 18.1877 5.12761ZM21.9227 6.46258C21.8393 4.70061 21.4368 3.13988 20.146 1.85399C18.8601 0.568098 17.2994 0.165644 15.5374 0.0773006C13.7215 -0.0257669 8.27853 -0.0257669 6.46258 0.0773006C4.70552 0.160736 3.14479 0.56319 1.85399 1.84908C0.56319 3.13497 0.165644 4.69571 0.0773006 6.45767C-0.0257669 8.27362 -0.0257669 13.7166 0.0773006 15.5325C0.160736 17.2945 0.56319 18.8552 1.85399 20.1411C3.14479 21.427 4.70061 21.8294 6.46258 21.9178C8.27853 22.0209 13.7215 22.0209 15.5374 21.9178C17.2994 21.8344 18.8601 21.4319 20.146 20.1411C21.4319 18.8552 21.8344 17.2945 21.9227 15.5325C22.0258 13.7166 22.0258 8.27853 21.9227 6.46258ZM19.5767 17.481C19.1939 18.4429 18.4528 19.184 17.4859 19.5718C16.038 20.146 12.6025 20.0135 11.0025 20.0135C9.40245 20.0135 5.96196 20.1411 4.51902 19.5718C3.55705 19.189 2.81595 18.4479 2.42822 17.481C1.85399 16.0331 1.9865 12.5975 1.9865 10.9975C1.9865 9.39755 1.8589 5.95706 2.42822 4.51411C2.81104 3.55215 3.55215 2.81104 4.51902 2.42331C5.96687 1.84908 9.40245 1.98159 11.0025 1.98159C12.6025 1.98159 16.0429 1.85399 17.4859 2.42331C18.4479 2.80613 19.189 3.54724 19.5767 4.51411C20.1509 5.96196 20.0184 9.39755 20.0184 10.9975C20.0184 12.5975 20.1509 16.038 19.5767 17.481Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(3.12%, 3.11%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "email" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M22 2.2C22 0.99 21.01 0 19.8 0L2.2 0C0.99 0 0 0.99 0 2.2L0 15.4C0 16.61 0.99 17.6 2.2 17.6L19.8 17.6C21.01 17.6 22 16.61 22 15.4L22 2.2ZM19.8 2.2L11 7.7L2.2 2.2L19.8 2.2ZM19.8 15.4L2.2 15.4L2.2 4.4L11 9.9L19.8 4.4L19.8 15.4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: {
                transform:
                  "translate(calc(50% - 11px - 0px), calc(50% - 8.8px - 0.2px))",
              },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "phone" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M12 0.00999999L2 0C0.9 0 0 0.9 0 2L0 20C0 21.1 0.9 22 2 22L12 22C13.1 22 14 21.1 14 20L14 2C14 0.9 13.1 0.00999999 12 0.00999999ZM12 18L2 18L2 4L12 4L12 18Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: {
                transform:
                  "translate(calc(50% - 7px - 0px), calc(50% - 11px - 0px))",
              },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "location" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M7.7 0C3.443 0 0 3.443 0 7.7C0 13.475 7.7 22 7.7 22C7.7 22 15.4 13.475 15.4 7.7C15.4 3.443 11.957 0 7.7 0ZM2.2 7.7C2.2 4.664 4.664 2.2 7.7 2.2C10.736 2.2 13.2 4.664 13.2 7.7C13.2 10.868 10.032 15.609 7.7 18.568C5.412 15.631 2.2 10.835 2.2 7.7Z",
              fill: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
            {
              d: "M2.75 5.5C4.26878 5.5 5.5 4.26878 5.5 2.75C5.5 1.23122 4.26878 0 2.75 0C1.23122 0 0 1.23122 0 2.75C0 4.26878 1.23122 5.5 2.75 5.5Z",
              fill: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.62%, 20.62%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "content" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M16 2L11.82 2C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2L2 2C0.9 2 0 2.9 0 4L0 20C0 21.1 0.9 22 2 22L16 22C17.1 22 18 21.1 18 20L18 4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM16 20L2 20L2 4L4 4L4 7L14 7L14 4L16 4L16 20Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 4.17%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "file" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M11 0L2.2 0C0.99 0 0.0110003 0.99 0.0110003 2.2L0 19.8C0 21.01 0.979 22 2.189 22L15.4 22C16.61 22 17.6 21.01 17.6 19.8L17.6 6.6L11 0ZM2.2 19.8L2.2 2.2L9.9 2.2L9.9 7.7L15.4 7.7L15.4 19.8L2.2 19.8Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 4.17%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "storage" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M19.8 2.2L11 2.2L8.8 0L2.2 0C0.99 0 0.011 0.99 0.011 2.2L0 15.4C0 16.61 0.99 17.6 2.2 17.6L19.8 17.6C21.01 17.6 22 16.61 22 15.4L22 4.4C22 3.19 21.01 2.2 19.8 2.2ZM19.8 15.4L2.2 15.4L2.2 4.4L19.8 4.4L19.8 15.4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 8.33%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "function" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M-0.40534 10.7072C-0.567018 10.9311 -0.516608 11.2436 -0.292745 11.4053C-0.0688824 11.567 0.243661 11.5166 0.40534 11.2927L-0.40534 10.7072ZM8.34975 0.292745C8.51143 0.0688824 8.46102 -0.243661 8.23716 -0.40534C8.01329 -0.567018 7.70075 -0.516608 7.53907 -0.292745L8.34975 0.292745ZM0.40534 11.2927L8.34975 0.292745L7.53907 -0.292745L-0.40534 10.7072L0.40534 11.2927Z",
              stroke: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              strokeLinejoin: "round",
              strokeWidth: 1,
              style: { transform: "translate(2.08%, 37.73%)" },
            },
            {
              d: "M14.6666 20.0555C14.9427 20.0555 15.1666 19.8316 15.1666 19.5555C15.1666 19.2793 14.9427 19.0555 14.6666 19.0555L14.6666 20.0555ZM0 -0.5C-0.276142 -0.5 -0.5 -0.276142 -0.5 0C-0.5 0.276142 -0.276142 0.5 0 0.5L0 -0.5ZM14.6666 19.0555C13.0959 19.0555 11.8521 18.0199 10.7365 16.2349C9.62274 14.453 8.72357 12.0611 7.80147 9.60218C6.89025 7.17225 5.95609 4.67525 4.77815 2.79054C3.60209 0.908843 2.09595 -0.5 0 -0.5L0 0.5C1.57071 0.5 2.81455 1.53559 3.93015 3.32054C5.04386 5.10248 5.94303 7.49435 6.86514 9.9533C7.77636 12.3832 8.71052 14.8802 9.88846 16.7649C11.0645 18.6466 12.5707 20.0555 14.6666 20.0555L14.6666 19.0555Z",
              stroke: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              strokeLinejoin: "round",
              strokeWidth: 1,
              style: { transform: "translate(7.18%, 2.08%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "authentication" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2 19L2 9L14 9L14 10C14.7 10 15.37 10.1 16 10.29L16 9C16 7.9 15.1 7 14 7L13 7L13 5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5L3 7L2 7C0.9 7 0 7.9 0 9L0 19C0 20.1 0.9 21 2 21L8.26 21C7.84 20.4 7.51 19.72 7.29 19L2 19ZM5 5C5 3.34 6.34 2 8 2C9.66 2 11 3.34 11 5L11 7L5 7L5 5Z",
              fill: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
            {
              d: "M5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM5 2C5.83 2 6.5 2.67 6.5 3.5C6.5 4.33 5.83 5 5 5C4.17 5 3.5 4.33 3.5 3.5C3.5 2.67 4.17 2 5 2ZM5 8C3.97 8 3.06 7.48 2.52 6.68C3.25 6.26 4.09 6 5 6C5.91 6 6.75 6.26 7.48 6.68C6.94 7.48 6.03 8 5 8Z",
              fill: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              style: { transform: "translate(37.5%, 50%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "data" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2.31579 11C2.31579 11.3624 2.84958 11.9935 4.08737 12.6129C5.68989 13.4142 7.96284 13.8947 10.4211 13.8947C12.8793 13.8947 15.1522 13.4142 16.7547 12.6129C17.9925 11.9935 18.5263 11.3624 18.5263 11L18.5263 8.48621C16.6158 9.66726 13.6944 10.4211 10.4211 10.4211C7.14768 10.4211 4.22632 9.66611 2.31579 8.48621L2.31579 11ZM18.5263 14.2757C16.6158 15.4567 13.6944 16.2105 10.4211 16.2105C7.14768 16.2105 4.22632 15.4556 2.31579 14.2757L2.31579 16.7895C2.31579 17.1519 2.84958 17.7829 4.08737 18.4024C5.68989 19.2037 7.96284 19.6842 10.4211 19.6842C12.8793 19.6842 15.1522 19.2037 16.7547 18.4024C17.9925 17.7829 18.5263 17.1519 18.5263 16.7895L18.5263 14.2757ZM0 16.7895L0 5.21053C0 2.33316 4.66632 0 10.4211 0C16.1758 0 20.8421 2.33316 20.8421 5.21053L20.8421 16.7895C20.8421 19.6668 16.1758 22 10.4211 22C4.66632 22 0 19.6668 0 16.7895ZM10.4211 8.10526C12.8793 8.10526 15.1522 7.62474 16.7547 6.82347C17.9925 6.204 18.5263 5.57295 18.5263 5.21053C18.5263 4.84811 17.9925 4.21705 16.7547 3.59758C15.1522 2.79632 12.8793 2.31579 10.4211 2.31579C7.96284 2.31579 5.68989 2.79632 4.08737 3.59758C2.84958 4.21705 2.31579 4.84811 2.31579 5.21053C2.31579 5.57295 2.84958 6.204 4.08737 6.82347C5.68989 7.62474 7.96284 8.10526 10.4211 8.10526Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 6.25%)" },
            },
          ],
        },
      },
    },
    {
      variantValues: { type: "home" },
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M9.41407 0.41681C9.73187 0.14769 10.1348 0 10.5513 0C10.9677 -5.20633e-16 11.3707 0.14769 11.6885 0.41681L20.4812 7.87655C20.6759 8.04162 20.8323 8.24708 20.9396 8.47869C21.0469 8.71029 21.1025 8.96248 21.1025 9.21773L21.1025 20.2415C21.1025 20.7079 20.9172 21.1551 20.5875 21.4849C20.2577 21.8147 19.8104 22 19.344 22L12.6029 22C12.3697 22 12.1461 21.9074 11.9812 21.7425C11.8163 21.5776 11.7236 21.3539 11.7236 21.1207L11.7236 13.7935L9.3789 13.7935L9.3789 21.1207C9.3789 21.3539 9.28626 21.5776 9.12137 21.7425C8.95647 21.9074 8.73282 22 8.49963 22L1.75854 22C1.29215 22 0.844856 21.8147 0.515065 21.4849C0.185275 21.1551 0 20.7079 0 20.2415L0 9.21773C0 8.70189 0.227438 8.21068 0.621352 7.87655L9.41407 0.41681ZM10.5513 1.75799L1.75854 9.21773L1.75854 20.2415L7.62036 20.2415L7.62036 12.9142C7.62036 12.681 7.71299 12.4573 7.87789 12.2925C8.04278 12.1276 8.26643 12.0349 8.49963 12.0349L12.6029 12.0349C12.8361 12.0349 13.0597 12.1276 13.2246 12.2925C13.3895 12.4573 13.4822 12.681 13.4822 12.9142L13.4822 20.2415L19.344 20.2415L19.344 9.21773L10.5513 1.75799Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 4.17%)" },
            },
          ],
        },
      },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Icon
      width="24px"
      height="24px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      viewBox={{ minX: 0, minY: 0, width: 24, height: 24 }}
      paths={[
        {
          d: "M0 19L22 19L11 0L0 19ZM12 16L10 16L10 14L12 14L12 16ZM12 12L10 12L10 8L12 8L12 12Z",
          fill: "rgba(92,102,112,1)",
          fillRule: "nonzero",
          style: { transform: "translate(4.17%, 12.5%)" },
        },
      ]}
      {...getOverrideProps(overrides, "MyIcon")}
      {...rest}
    ></Icon>
  );
}
